export var evaluateDocs = {
  name: 'evaluate',
  category: 'Expression',
  syntax: ['evaluate(expression)', 'evaluate([expr1, expr2, expr3, ...])'],
  description: 'Evaluate an expression or an array with expressions.',
  examples: ['evaluate("2 + 3")', 'evaluate("sqrt(" + 4 + ")")'],
  seealso: []
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/es/expression/embeddedDocs/function/expression/evaluate.js
// module id = 1245
// module chunks = 0